/**
 * Respaldo de una apertura para mostrar: las referencias cargadas o el JSON completo.
 * @param {Object|null} evidence Evidencia guardada con la apertura.
 * @returns {string} Texto del respaldo.
 */
export const formatOpeningEvidence = (evidence) => {
  if (!evidence) return '';
  if (typeof evidence.references === 'string') return evidence.references;
  return JSON.stringify(evidence);
};
